import Identity from './identity';
import { SocialSignOnProviders } from './socialSignOnTypes';
import { isUserIdentity } from './userIdentity';

import { headers as defaultHeaders, PROFILE_STORAGE_KEY_EXPIRED_TIME } from './constants';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

/** @hidden */
export async function socialLogin(
  type: SocialSignOnProviders,
  identity: { credentials: string }
) {
  const headers: { [index: string]: any } = {
    ...defaultHeaders
  };

  if (
    Identity.userIdentity &&
    Identity.userIdentity.accessToken &&
    Identity.userIdentity.refreshToken
  ) {
    await Identity.heartbeat();
    headers['Authorization'] = `Bearer ${Identity.userIdentity.accessToken}`;
  }

  return fetch(`${Identity.apiOrigin}/identity/public/v1/auth/login`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      ...identity,
      userName: '',
      grantType: type
    })
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isUserIdentity(json)) {
        localStorage.removeItem(PROFILE_STORAGE_KEY_EXPIRED_TIME);

        Identity.userIdentity = json;
        window.postMessage({ type: 'ARC_LOGIN_SUCCESS', grantType: type }, '*');
        return json;
      } else {
        throw json;
      }
    });
}
